import { Row, Col, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { useNavigate as useHistory } from 'react-router-dom';

function CaratteristicheClassificazioniBox() {
  const history = useHistory();

  useEffect(() => {
    document.title = 'Caratteristiche e classificazioni delle unità territoriali - SITUAS';
  });

  return (
    <div>
      <button
        tabIndex="0"
        aria-hidden="arrow-left"
        id="TornaIndietro-btn"
        onClick={() => {
          history(`/home`);
        }}>
        <ArrowLeftOutlined />
        <span>Indietro</span>
      </button>

      <Row className="box">
        <Col xs={24}>
          <h2 className="title-main">Caratteristiche e classificazioni delle unità territoriali</h2>
          <Divider className="blue-divider" />

          <div>
            L’Istat elabora classificazioni a fini statistici assegnate alle unità territoriali, ad
            esempio: la litoraneità, la zona altimetrica, il grado di urbanizzazione, ecc. Sono
            inoltre rese disponibili classificazioni predisposte da altri enti a fini di policy (es.
            aree interne) o derivanti da Regolamenti europei.
          </div>
          <Link className="box-linkto" to="/territorio">
            Vai alla sezione Unità territoriali
          </Link>
        </Col>
      </Row>
    </div>
  );
}
export default CaratteristicheClassificazioniBox;
